import React, { useEffect, useState } from 'react';
import { env } from '../../../env';
import { observable, Observer } from '@poa/state';
import Spinner from 'react-spinkit';
import { validateFee } from '../../../utils/fee';
import LaddaButton, { SLIDE_UP, XL } from 'react-ladda';
import AutosizeInput from 'react-input-autosize';


export function sleep(ms) {
  return new Promise(r => setTimeout(r, ms));
}

function ChangableInputRow({
  isInputsActive,
  label,
  data,
  item,
  type = 'number'
}) {
  return (
    <li className="account-info__item">
      <div className="account-info__name">{label}</div>
      <Observer>
        {() => (
          <AutosizeInput
            minWidth={150}
            disabled={isInputsActive}
            inputClassName="account-info__val"
            type={type}
            min={0}
            max={100}
            value={data[item]}
            onChange={(e) => {data[item] = e.target.value;}}
          />
        )}
      </Observer>
    </li>
  );
}

const SettingAgency = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [saving, setSaving] = useState(false);
  const [mappedData, setMappedData] = useState({});


  useEffect(() => {
    async function fetch() {
      try {
        setError(false);
        const { data } = await env.http.get('agency');
        setData(data);
        setMappedData(
          observable({
            ...data.data
          })
        );
      } catch (e) {
        setError(true);
        console.error(e);
      } finally {
        setLoading(false);
      }
    }
    fetch();
  }, []);

  async function onSave() {
    if (saving) {
      return;
    }

    setSaving(true);

    try {
      await Promise.all([
        sleep(1000),
        env.http.post('agency', { ...mappedData })
      ]);
      env.alert('Успех', `Агенство успешно обновленно!`);
    } catch (e) {
      env.alert('Ошибка', `Ошибка при создании агенства`, 'error');
      console.error(e);
    } finally {
      setSaving(false);
    }
  }

  if (loading) {
    return <Spinner name="chasing-dots" />;
  }

  if (error) {
    return 'Неудалось загрузить данние';
  }

  if (!data) {
    return 'Нету данных для отображения';
  }

  return (
    <div className="account-info__left">
      <ul className="account-info__list">
        <ChangableInputRow
          label="Сайт %"
          data={mappedData}
          item="fee"
          validator={validateFee}
        />
        <ChangableInputRow
          label={data.labels.manager_default_percent_verbose}
          data={mappedData}
          item="manager_default_percent"
        />
        <ChangableInputRow
          label={data.labels.teamlead_default_percent_verbose}
          // data={data.data.teamlead_default_percent}
          data={mappedData}
          item="teamlead_default_percent"
        />
        <ChangableInputRow
          label={data.labels.operator_default_percent_verbose}
          data={mappedData}
          item="operator_default_percent"
        />
        <ChangableInputRow
          label={data.labels.gift_default_percent_verbose}
          data={mappedData}
          item="gift_default_percent"
        />
        <ChangableInputRow
          label={data.labels.present_default_percent_verbose}
          data={mappedData}
          item="present_default_percent"
        />
              <LaddaButton
        loading={saving}
        onClick={onSave}
        type="submit"
        data-color="#eee"
        style={{
          width: 140,
          height: 40,
          backgroundColor: '#4cc462',
          marginTop: 25,
          marginRight: 25,
          borderRadius: 4,
          fontSize: 8
        }}
        data-size={XL}
        data-style={SLIDE_UP}
        data-spinner-size={30}
        data-spinner-color="#ddd"
        data-spinner-lines={12}
      >
        Сохранить
      </LaddaButton>
      </ul>
    </div>
  );
}


export default SettingAgency;